export interface FinancialData {
  type: "financial_datas"
  id: string
  attributes: {
    fiscal_monthly_key: string
    fiscal_quaterly_key: string
    fiscal_year_key: string
    account_level: string
    measure_type: string
    value: number
    period_date: number
    period_label: string
  }
  relationships: {
    asset: {
      type: string
      id: string
    }
    financial_account: {
      type: string
      id: string
    }
  }
}

export const financialDataAttributes = ["period_label", "period_date"]
